import { OrderStatus, OrderType } from "enums/orders";
import { theme } from "styles/theme";

export const showStatusText = (winlose: number) => {
  switch (true) {
    case winlose > 0:
      return "Win:";
    case winlose < 0:
      return "Lose:";
    default:
      return "Draw:";
  }
};

export const showStatusTransaction = (status: OrderStatus) => {
  switch (status) {
    case OrderStatus.Pending:
      return "Chờ phê duyệt";
    case OrderStatus.Approve:
      return "Đã chấp thuận";
    case OrderStatus.Reject:
      return "Từ chối";
    case OrderStatus.Processing:
      return "Đang xử lý";
    default:
      return "";
  }
};

export const handleColorStatus = (winlose: number) => {
  switch (true) {
    case winlose > 0:
      return "#0477FD";
    case winlose < 0:
      return "#F1212A";
    default:
      return theme.colors.gray[850];
  }
};

export const handleColorStatusTransaction = (status: OrderStatus) => {
  switch (status) {
    case OrderStatus.Approve:
      return "#10AC02";
    case OrderStatus.Pending:
      return "#EDA10F";
    case OrderStatus.Processing:
      return "#0477FD";
    case OrderStatus.Reject:
      return "#F1212A";
  }
};

export const showAmount = (orderType?: OrderType, amount?: string) => {
  let valueType = "";
  switch (orderType) {
    case OrderType.DEPOSIT:
      valueType = "+";
      break;
    case OrderType.WITHDRAWAL:
      valueType = "-";
      break;
  }
  return valueType + " " + amount;
};

export const utilShowQueue = (queue: string) => {
  const queueNumber = Number(queue);

  if (queueNumber >= 0) return `- Queue: ${queue}`;

  return "";
};
